<template lang="pug">
  #app
    .contenedor
      header
        .logo
          img(:src='logo')
        .information
          p.fc-empresa FORMULARIO DE DENUNCIA

      section.body
        .section.box.datos-denunciante
          transition(name="fade", mode="out-in")
            .anonimo(
              v-if="isAnonimo"
              key="anonimo"
            )
              .explanation
                p.subtitle Denunciante anónimo
                a(
                  @click="isAnonimo = false"
                ) No deseo realizar mi denuncia como anónimo
            .no-anonimo(
              v-else
              key="no-anonimo"
            )
              .explanation
                p.subtitle Datos del denunciante
                a(
                  @click="isAnonimo = true"
                ) Deseo realizar mi denuncia como anónimo
              
              hr

              article.message.is-info
                .message-body
                  span Si no desea ser identificado, podrá ingresar su denuncia en forma 
                  strong anónima 
                  span , sin embargo, para que pueda ser evaluada deberá 
                  strong imprescindiblemente 
                  span consignar documentación probatoria o información verificable 
                  span que permita la evaluación respectiva.
                  
              .field
                label.label Apellidos y nombres completos / denominación o razón social:
                .control
                  input.input(type='text', v-model="nombre")
              
              .field
                label.label Documento de identidad
                .control
                  input.input(type='number', v-model="dni")
              
              .field
                label.label Correo electrónico
                .control
                  input.input(type='email', v-model="email")
              
              .field
                label.label Teléfono
                .control
                  input.input(type='text', v-model="telefono")
    
        .section.box

          p.subtitle Datos de la denuncia

          hr

          .field
            label.label 
              | Describa de forma clara y precisa, indicando la fecha en que habría acontecido 
              | el hecho. Adjunte pruebas sustentorias de las irregularidades.
            .control
              textarea.textarea(rows='5', v-model="textoDenuncia")
          
          .section-adjuntar   
            a.button.is-empresa(
              v-on:click="$upload.select('denuncia')",
              :class="{'is-loading': $upload.meta('denuncia').status === 'sending'}"
            )
              span.icon.is-small
                i.fa.fa-file-pdf-o
              span(v-if="filename") Adjuntar PDF
              span(v-else) Adjuntar PDF

            .adjuntado      
              div(v-if="$upload.files('denuncia').error.length")
                span {{ $upload.files('denuncia').error[0].errors[0].message }}

              div(v-if="filename")
                span.icon
                  i.fa.fa-file-pdf-o
                
                span.name {{ fileSubido.originalname }}
        
        .section.box

          p.subtitle Miembros de comité anticorrupción

          hr

          article.message.is-warning
            .message-body
              span Estos son los miembros de nuestro comité anticorrupción.
              br
              span Si en su denuncia usted sabe o cree que un miembro del comité 
              strong está implicado
              span , por favor márquelo con un 
              strong check.
              br
              span De esta forma nos ayudará a manejar la denuncia correctamente, ya que no se le notificará acerca de esta.

          .miembros
            label.checkbox(
              v-for="o in miembros"
            )
              input(
                type='checkbox'
                v-model="o.isChecked"
              )
              span {{ o.cargo }}

        div
          vue-recaptcha.recaptcha-container(
            ref="recaptcha"
            @verify="onVerify"
            @expired="onExpired"
            :sitekey="sitekey"
          )
          
        .section
          .boton-enviar
            a.button.is-empresa(
              :class="{'is-loading': isSending}"
              @click="send"
            )
              span.icon.is-small
                i.fa.fa-send-o
              span Enviar denuncia

    notifications  

              
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
export default {
  name: 'app',
  components: { VueRecaptcha },
  data () {
    return {
      isAnonimo: true,
      nombre: '',
      dni: '',
      email: '',
      telefono: '',
      textoDenuncia: '',
      miembros: [],
      isSending: false,
      requestRoute : '',
      fileSubido: '',
      filename: '',
      verifyRecaptcha: '',
      sitekey: 'fer',
      logo: 'fer'
    }
  },
  created () {
    this.requestRoute = process.env.NODE_ENV === 'production' ? 'https://api-helpdesk.datacont.com' : 'http://localhost:3000'
    this.sitekey      = process.env.RECAPTCHA_KEY
    this.logo         = process.env.logo
    this.fetchMiembros()
    this.$upload.new('denuncia', {
      url: this.requestRoute + '/upload/pdf',
      maxSizePerFile: 5120,
      extensions: ['pdf'],
      http: this.methodUpload,
      onSuccess(res) {
        console.log('success:', res)
        console.log('res.file:', res.file)
        this.fileSubido = res.data.file
        this.filename   = res.data.file.filename
      },
      onError (err) {
        console.error('err: ', err)
        this.fileSubido = {}
        this.filename = ''
      }
    });
  },
  methods: {
    fetchMiembros () {
      var vm = this

      this.requestRoute = process.env.NODE_ENV === 'production' ? 'https://api-helpdesk.datacont.com' : 'http://localhost:3000'
      
      axios.get(this.requestRoute + '/denuncia/miembros?empresa=' + process.env.empresa)
      .then(function (response) {
        console.log(response.data.lista);
        vm.miembros = response.data.lista
      })
      .catch(function (error) {
        console.log(error);
      });
    },
    send () {
      var vm = this
      this.isSending = true

      this.requestRoute = process.env.NODE_ENV === 'production' ? 'https://api-helpdesk.datacont.com' : 'http://localhost:3000'
      
      if (!vm.verifyRecaptcha) {
        vm.isSending = false
        vm.notify('error', 'Hay inconvenientes', 'Por favor de click al reCAPTCHA ')
        return
      }

      var obj = {
        textoDenuncia : vm.textoDenuncia,
        isAnonimo     : vm.isAnonimo,
        miembros      : vm.miembros,
        empresa       : process.env.empresa,
        filename      : vm.filename,
        fileSubido    : vm.fileSubido,
        recaptcha     : vm.verifyRecaptcha
      }

      if (!this.isAnonimo) {
        obj.isAnonimo = false
        obj.nombre   = vm.nombre
        obj.dni      = vm.dni
        obj.email    = vm.email
        obj.telefono = vm.telefono
      }

      if (!obj.textoDenuncia) {
        vm.notify('error', 'Hay algunos inconvenientes', 'Por favor ingrese el comentario de su denuncia')
        vm.isSending = false
        return
      }

      axios.post(this.requestRoute + '/denuncia', obj)
      .then(function (response) {
        console.log(response);
        vm.isSending = false
        if (response.data.status) {
          vm.notify('success', 'Éxito', 'Su denuncia fue enviada correctamente')
        } else {
          vm.notify('error', 'Error', response.data.message)
        }
      })
      .catch(function (error) {
        console.log(error);
        vm.isSending = false
        vm.notify('error', 'Éxito', 'Su denuncia fue enviada correctamente')
      });

    },
    notify (type, title, text) {
      this.$notify({
        title   : title,
        text    : text,
        position: 'bottom right',
        type    : type
      });
    },
    methodUpload (data) {
      var vm = this

      var obj = data.body

      axios.post(data.url, obj).then(data.success).catch(data.error)
    },
    clearUpload () {
      var vm = this
      vm.$upload.reset('denuncia', {
        url: this.requestRoute + '/upload/pdf',
        http: vm.methodUpload
      })
    },
    onVerify: function (response) {
      console.log('Verify: ' + response)
      this.verifyRecaptcha = response
    },
    onExpired: function () {
      console.log('Expired')
      this.verifyRecaptcha = ''
    },
    resetRecaptcha () {
      this.$refs.recaptcha.reset() // Direct call reset method
      this.verifyRecaptcha = ''
    }
  }
}
</script>

<style lang="stylus">
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
    display: flex;
    justify-content: center;
  }

  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  header
    display flex
    flex-direction column
    justify-content  center
    margin-bottom 20px
    
    .logo
      img 
        width: 250px;

    .information
      font-weight bold
      font-size: 27px;


  .contenedor
    padding 5px 50px
    max-width: 800px;

    
  .body
    text-align left

  .subtitle
    font-weight bold
    font-size: 23px;
    margin-bottom 0px !important
  
  .checkbox
    span 
      margin-left 10px
  
  .miembros
    display flex
    flex-direction column
  
  .boton-enviar
    text-align center
  
  .section-adjuntar
    display flex
    justify-content center
    align-items center
    .adjuntado
      .icon
        margin-left 10px
      .name
        color #ababab
        margin-left 5px
  
  .section
    margin-bottom 0
  
  .datos-denunciante
    .explanation
      a
        font-size 13px
  
  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s ease;
  }
  .fade-enter, .fade-leave-to
    opacity: 0;
  
  .recaptcha-container
    display flex 
    justify-content center
    
</style>



// WEBPACK FOOTER //
// src/App.vue